import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  IconCalendarStats,
  IconDeviceDesktopAnalytics,
  IconFingerprint,
  IconGauge,
  IconHome2,
  IconUser,
  IconSettings,
} from "@tabler/icons-react";
import Header from "../Components/Header";

// Quick access grid items with icons
const quickAccessItems = [
  { 
    icon: IconDeviceDesktopAnalytics, 
    title: "Devices", 
    path: "/devices",
    color: "bg-blue-50"
  },
  { 
    icon: IconUser, 
    title: "Users", 
    path: "/users",
    color: "bg-green-50"
  },
  { 
    icon: IconGauge, 
    title: "Sites", 
    path: "/Maps",
    color: "bg-purple-50"
  },
  { 
    icon: IconCalendarStats, 
    title: "Recharge", 
    path: "/Recharge",
    color: "bg-amber-50"
  }
];



// Activity data for the recent activity section
const recentActivities = [
  {
    icon: IconUser,
    title: "New user registered",
    time: "2 hours ago",
    description: "John Doe created an account"
  },
  {
    icon: IconDeviceDesktopAnalytics,
    title: "Device status updated",
    time: "4 hours ago",
    description: "Server #28 is now online"
  },
  {
    icon: IconFingerprint,
    title: "Login attempt detected",
    time: "Yesterday",
    description: "Unusual login from new location"
  }
];

export function DashboardView() {
  const navigate = useNavigate();

  const removeToken =()=>{
    
    localStorage.removeItem('token')
    localStorage.removeItem('username')
    localStorage.removeItem('role')
    navigate("/")
    }
  
  return (
    <div className="bg-gray-100 min-h-screen">
      <Header/>
      
      {/* Main content area */}
      <main className="p-4 md:p-8 max-w-7xl mx-auto">
        <div className="mb-8">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2">Welcome back!</h1>
          <button onClick={removeToken} className="float-right items-center bg-black text-white m-2 p-2 rounded-md">Logout</button>
        </div>
        
        {/* Quick access grid */}
        <section>
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-xl font-semibold text-gray-800">Quick Access</h2>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {quickAccessItems.map((item) => (
              <div 
                key={item.title}
                className={`rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 cursor-pointer ${item.color}`}
                onClick={() => navigate(item.path)}
              >
                <div className="flex flex-col items-center p-6">
                  <div className="mb-4 p-4 rounded-full bg-white shadow-sm">
                    <item.icon size={28} className="text-gray-700" />
                  </div>
                  <p className="text-lg font-medium text-gray-800">{item.title}</p>
                </div>
              </div>
            ))}
          </div>
        </section>
        
        <section className="mt-12">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-xl font-semibold text-gray-800">Dashboard Summary</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
            <div className="bg-white rounded-xl shadow-sm p-6">
              <div className="flex items-center justify-between mb-2">
                <h3 className="text-gray-500 font-medium">Total Devices</h3>
                <IconDeviceDesktopAnalytics size={24} className="text-blue-500" />
              </div>
              <p className="text-3xl font-bold text-gray-800">128</p>
              <p className="text-green-500 text-sm mt-2">+5 since last week</p>
            </div>
            
            <div className="bg-white rounded-xl shadow-sm p-6">
              <div className="flex items-center justify-between mb-2">
                <h3 className="text-gray-500 font-medium">Active Users</h3>
                <IconUser size={24} className="text-green-500" />
              </div>
              <p className="text-3xl font-bold text-gray-800">56</p>
              <p className="text-green-500 text-sm mt-2">+12 since last week</p>
            </div>
            
            <div className="bg-white rounded-xl shadow-sm p-6">
              <div className="flex items-center justify-between mb-2">
                <h3 className="text-gray-500 font-medium">Active Sites</h3>
                <IconGauge size={24} className="text-purple-500" />
              </div>
              <p className="text-3xl font-bold text-gray-800">24</p>
              <p className="text-red-500 text-sm mt-2">-2 since last week</p>
            </div>
          </div>
        </section>
        
        {/* Recent activity section */}
        <section className="mt-12">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-xl font-semibold text-gray-800">Recent Activity</h2>
            <button className="text-blue-600 hover:text-blue-800 text-sm font-medium">View all</button>
          </div>
          <div className="bg-white rounded-xl shadow-sm">
            <div className="divide-y divide-gray-100">
              {recentActivities.map((activity, index) => (
                <div key={index} className="p-4 md:p-6 hover:bg-gray-50 transition-colors">
                  <div className="flex items-start">
                    <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center mr-4">
                      <activity.icon size={20} className="text-gray-500" />
                    </div>
                    <div>
                      <p className="font-medium text-gray-800">{activity.title}</p>
                      <p className="text-sm text-gray-500">{activity.description}</p>
                      <p className="text-xs text-gray-400 mt-1">{activity.time}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default DashboardView;